export default __webpack_public_path__ + "static/media/timer_play.3f76226a.svg";